<template>
  <div class="abp-page">
    <div class="abp-container">
      <!-- 面包屑导航 -->
      <nav class="breadcrumb-nav">
        <router-link to="/">首页</router-link>
        <span class="separator">/</span>
        <router-link to="/product">产品中心</router-link>
        <span class="separator">/</span>
        <span class="current">审计经营画像</span>
      </nav>
    </div>

    <!-- 英雄区 -->
    <section class="abp-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1>企业审计经营画像与智慧审计评价系统<br><span style="color: var(--abp-accent-blue);">科技强审 · 研究型审计 · 多维度画像</span></h1>
        <p class="subhead">构建企业经营多维度画像，融合大数据审计与研究型审计，推动审计从"问题发现型"向"决策辅助型"升级，满足中央审计委员会"科技强审"要求。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="btn btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="keyword-cloud">
        <h2 class="keyword-tag highlight">企业审计经营画像</h2>
        <h2 class="keyword-tag">智慧审计</h2>
        <h2 class="keyword-tag">大数据审计</h2>
        <h2 class="keyword-tag">研究型审计</h2>
        <h2 class="keyword-tag">审计监督评价</h2>
        <h2 class="keyword-tag">企业经营画像</h2>
        <h2 class="keyword-tag">企业能力画像</h2>
        <h2 class="keyword-tag">风险画像</h2>
        <h2 class="keyword-tag">审计数字化转型</h2>
        <h2 class="keyword-tag">科技强审</h2>
      </div>
    </section>

    <!-- 背景与挑战 -->
    <section class="abp-container">
      <h2><i class="fa-regular fa-triangle-exclamation"></i> 科技强审背景下的新挑战</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-chart-simple"></i></div>
          <h3>传统审计模式局限</h3>
          <p>以问题发现为主，缺乏对企业整体经营的多维度分析，难以支撑领导层决策。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-cube"></i></div>
          <h3>数据价值未充分挖掘</h3>
          <p>审计数据分散，未形成企业级经营画像资产，无法实现持续监督与趋势分析。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-microscope"></i></div>
          <h3>研究型审计落地难</h3>
          <p>缺乏工具支撑深度分析与行业对标，审计成果难以转化为经营洞察。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 1.1rem;">中央审计委员会强调"解放思想、与时俱进，推动科技强审，加强大数据审计应用，开展研究型审计"。企业经营画像系统正是响应这一要求的关键工具。</p>
    </section>

    <!-- 解决方案核心能力 -->
    <section class="abp-container">
      <h2><i class="fa-regular fa-cubes"></i> 四大核心能力 · 构建企业经营画像</h2>
      <div class="card-grid-4">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-chart-pie"></i></div>
          <h3>多维度画像构建</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 财务能力维度</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 经营绩效维度</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险合规维度</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 内控管理维度</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-magnifying-glass-chart"></i></div>
          <h3>大数据审计分析</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 全量数据扫描</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 异常波动检测</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 关联规则挖掘</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-arrow-right-arrow-left"></i></div>
          <h3>企业能力对标</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 行业基准对比</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 历史趋势分析</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 优势短板识别</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-file-signature"></i></div>
          <h3>智慧审计评价</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 自动生成评价报告</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险等级量化</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 经营健康度评分</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 画像维度深度展示 -->
    <section class="abp-container">
      <h2><i class="fa-regular fa-id-card"></i> 企业经营画像 · 五大核心维度</h2>
      <div class="dimension-grid">
        <div class="dimension-item">财务健康度</div>
        <div class="dimension-item">经营效率</div>
        <div class="dimension-item">风险暴露</div>
        <div class="dimension-item">合规水平</div>
        <div class="dimension-item">内控有效性</div>
      </div>
      <div class="arch-card">
        <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center; justify-content: center; margin-bottom: 30px;">
          <span class="compliance-badge">雷达图展示</span>
          <span class="compliance-badge">多期对比</span>
          <span class="compliance-badge">行业对标</span>
          <span class="compliance-badge">健康度评分</span>
        </div>
        <div class="arch-grid">
          <div class="arch-item">
            <i class="fa-regular fa-circle-radar" style="font-size: 2rem; color: var(--abp-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>综合画像雷达图</h4>
            <p>五大维度归一化展示，直观呈现企业整体经营状态，支持钻取查看细分指标。</p>
          </div>
          <div class="arch-item">
            <i class="fa-regular fa-chart-line" style="font-size: 2rem; color: var(--abp-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>多期趋势对比</h4>
            <p>按季度/年度展示各维度变化趋势，识别经营能力提升或下滑，辅助长期跟踪。</p>
          </div>
          <div class="arch-item">
            <i class="fa-regular fa-building" style="font-size: 2rem; color: var(--abp-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>行业对标分析</h4>
            <p>与同行业标杆企业对比，定位企业在行业中的相对位置与改进空间。</p>
          </div>
        </div>
        <p style="margin-top: 30px; text-align: center;">画像结果可直接用于 <strong>领导决策参考、风险预警、绩效评估、审计计划制定</strong>。</p>
      </div>
    </section>

    <!-- 应用场景 -->
    <section class="abp-container">
      <h2><i class="fa-regular fa-building"></i> 典型应用场景</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <h3>企业年度经营健康度评价</h3>
          <p>结合财务、经营、风险等数据，自动生成企业经营健康度评分与报告，为管理层提供全景视角。</p>
        </div>
        <div class="feature-card">
          <h3>研究型审计深度分析</h3>
          <p>支持按行业、区域、规模等维度进行多企业对比分析，挖掘共性风险与优秀实践。</p>
        </div>
        <div class="feature-card">
          <h3>审计计划与资源配置</h3>
          <p>根据画像结果识别高风险领域，优化审计资源配置，实现精准审计。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="abp-container">
      <h2><i class="fa-regular fa-chart-simple"></i> 关键成果与价值</h2>
      <div class="stat-grid">
        <div class="stat-card">
          <div class="stat-number">100%</div>
          <p>经营数据统一画像</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">30%+</div>
          <p>审计分析深度提升</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">50%+</div>
          <p>决策支撑效率提升</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">多年度</div>
          <p>历史趋势沉淀</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none; display: flex; flex-wrap: wrap; gap: 30px; justify-content: center;">
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 推动审计从"问题发现型"向"决策辅助型"升级</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 满足中央审计委员会"科技强审"与"研究型审计"要求</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 构建企业级审计数据资产，实现持续监督与趋势分析</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 提升审计成果转化应用能力，支撑企业治理现代化</li>
        </ul>
      </div>
    </section>

    <!-- 适用客户类型 -->
    <section class="abp-container">
      <h2><i class="fa-regular fa-users"></i> 适用客户群体</h2>
      <div class="client-tags">
        <span class="client-tag">中央企业集团</span>
        <span class="client-tag">地方国资委监管企业</span>
        <span class="client-tag">金融机构</span>
        <span class="client-tag">能源/电力/通信企业</span>
        <span class="client-tag">大型上市公司</span>
        <span class="client-tag">审计机关</span>
        <span class="client-tag">内审部门</span>
        <span class="client-tag">风险管理部门</span>
      </div>
    </section>

    <!-- 客户成功案例 -->
    <section class="abp-container">
      <h2><i class="fa-regular fa-briefcase"></i> 客户成功案例</h2>
      <div class="card-grid-3">
        <div class="case-card">
          <i class="fa-solid fa-building-columns" style="font-size: 2rem; color: var(--abp-primary-dark);"></i>
          <div class="case-stats">-40%</div>
          <p><strong>某能源央企</strong> — 通过企业经营画像，发现海外子公司经营效率短板，针对性审计后挽回潜在损失超亿元。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-phone" style="font-size: 2rem; color: var(--abp-primary-dark);"></i>
          <div class="case-stats">+60%</div>
          <p><strong>省级通信集团</strong> — 画像系统实现全省21家地市公司经营健康度排名，审计计划精准度提升60%。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-truck" style="font-size: 2rem; color: var(--abp-primary-dark);"></i>
          <div class="case-stats">100%</div>
          <p><strong>大型制造企业</strong> — 多维度画像覆盖所有分子公司，每年自动生成经营审计白皮书，支撑董事会决策。</p>
        </div>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="abp-container">
      <h2 style="text-align: center;"><i class="fa-regular fa-circle-question"></i> 常见问题</h2>
      <div class="faq-list">
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 画像维度如何确定？能否定制？</div>
          <div class="faq-answer">系统预置通用企业画像维度（财务、经营、风险、合规、内控），并支持根据行业特点、管理需求自定义扩展，权重可灵活配置。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 数据来源有哪些？如何保证数据质量？</div>
          <div class="faq-answer">可对接ERP、财务系统、业务系统、审计平台等多源数据。系统内置数据清洗与校验规则，确保画像基础数据准确可靠。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 是否支持与现有审计系统集成？</div>
          <div class="faq-answer">支持标准API接口，可无缝对接古杉非现场审计平台及其他主流审计系统，实现审计数据自动同步与画像结果回写。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 如何利用画像结果指导审计工作？</div>
          <div class="faq-answer">画像高风险维度可自动触发预警，辅助审计计划制定；画像报告可作为审前分析依据，提升审计针对性。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 实施周期需要多久？</div>
          <div class="faq-answer">一般2-3个月完成试点上线，包括指标体系梳理、数据接入、模型配置和人员培训。提供敏捷交付模式。</div>
        </div>
      </div>
    </section>

    <!-- 最终CTA -->
    <section class="abp-container" style="padding-bottom: 80px;">
      <div class="cta-block">
        <h2 style="font-size: 2.4rem;">开启智慧审计与企业经营画像新时代</h2>
        <p style="font-size: 1.2rem; margin: 16px 0 40px; opacity: 0.9;">预约专家演示，了解如何构建企业经营多维度画像，实现科技强审与研究型审计落地。</p>
        <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal" style="background: white; color: var(--abp-primary-dark);">预约免费演示</a>
          <a href="tel:4008881234" class="btn btn-outline" style="border-color: white; color: white;">致电 400-888-1234</a>
        </div>
        <p style="margin-top: 32px; font-size: 1rem;"><i class="fa-regular fa-envelope"></i> 发送需求至 portrait@gushandata.cn</p>
      </div>
    </section>

    <!-- 预约演示模态框 -->
    <div class="modal" :style="{ display: showModal ? 'flex' : 'none' }">
      <div class="modal-content">
        <span class="close-modal" @click="closeModal">&times;</span>
        <h3><i class="fa-regular fa-calendar-check" style="color: var(--abp-primary-dark);"></i> 预约专家演示</h3>
        <form @submit.prevent="submitDemo">
          <div class="form-group">
            <input type="text" v-model="form.name" placeholder="姓名 *" required>
          </div>
          <div class="form-group">
            <input type="text" v-model="form.company" placeholder="公司名称">
          </div>
          <div class="form-group">
            <input type="email" v-model="form.email" placeholder="工作邮箱 *" required>
          </div>
          <div class="form-group">
            <input type="tel" v-model="form.phone" placeholder="联系电话">
          </div>
          <div class="form-group">
            <textarea rows="3" v-model="form.message" placeholder="您的需求或问题（选填）"></textarea>
          </div>
          <button type="submit" class="btn btn-primary">提交预约</button>
        </form>
      </div>
    </div>

    <!-- footer -->
    <footer class="abp-container">
      <p>© 2026 古杉数据 · 企业审计经营画像与智慧审计评价系统 | 科技强审 · 研究型审计 · 多维度画像</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AuditBusinessProfileDetail',
  data() {
    return {
      showModal: false,
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitDemo() {
      alert('感谢您的预约，古杉数据专家将在24小时内与您联系。');
      this.showModal = false;
      this.form = { name: '', company: '', email: '', phone: '', message: '' };
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    }
  }
};
</script>

<style scoped>
.abp-page {
  --abp-primary-dark: #1D4E4E;
  --abp-primary-soft: #e9f3f2;
  --abp-accent-gold: #D4AF37;
  --abp-accent-blue: #2A7DE1;
  --abp-gray-light: #f8fafc;
  --abp-gray-border: #e2e8f0;
  --abp-text-dark: #0f2a2a;
  --abp-text-regular: #2d3f4b;
  --abp-white: #ffffff;
  --abp-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  background-color: #ffffff;
  color: var(--abp-text-regular);
  line-height: 1.5;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 面包屑导航 */
.breadcrumb-nav {
  padding: 20px 0;
  font-size: 0.9rem;
  border-bottom: 1px solid var(--abp-gray-border);
  margin-bottom: 20px;
}

.breadcrumb-nav a {
  color: var(--abp-primary-dark);
  text-decoration: none;
  font-weight: 500;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--abp-accent-blue);
  font-weight: 600;
}

.abp-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

section.abp-container {
  padding: 64px 24px;
}

h1, h2, h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--abp-text-dark);
}

h1 {
  font-size: 3.2rem;
  line-height: 1.2;
}

h2 {
  font-size: 2.2rem;
  margin-bottom: 24px;
}

h2 i {
  color: var(--abp-accent-blue);
  margin-right: 8px;
}

h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.subhead {
  font-size: 1.2rem;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.btn-primary {
  background-color: var(--abp-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--abp-primary-dark);
  color: var(--abp-primary-dark);
}

.btn-outline:hover {
  background-color: var(--abp-primary-dark);
  color: white;
}

.btn-accent {
  background-color: var(--abp-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 关键词标签云 */
.keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.keyword-tag {
  background: var(--abp-primary-soft);
  color: var(--abp-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.keyword-tag.highlight {
  background: var(--abp-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.card-grid-3, .card-grid-4 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--abp-shadow);
  border: 1px solid var(--abp-gray-border);
  transition: transform 0.2s;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.card-icon {
  font-size: 2.5rem;
  color: var(--abp-primary-dark);
  margin-bottom: 20px;
}

.list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.list-item i {
  color: var(--abp-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.stat-card {
  background: var(--abp-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--abp-primary-dark);
  margin-bottom: 8px;
}

.client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.client-tag {
  background: white;
  border: 1px solid var(--abp-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--abp-text-dark);
}

.case-card {
  background: white;
  border-radius: 24px;
  padding: 28px;
  box-shadow: var(--abp-shadow);
}

.case-stats {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--abp-primary-dark);
  margin: 16px 0 8px;
}

/* 画像维度卡片 */
.dimension-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin: 30px 0;
}

.dimension-item {
  background: var(--abp-primary-soft);
  border-radius: 40px;
  padding: 16px 8px;
  text-align: center;
  font-weight: 600;
  color: var(--abp-primary-dark);
}

/* 技术架构卡片 */
.arch-card {
  background: var(--abp-primary-soft);
  border-radius: 32px;
  padding: 36px;
  margin-top: 30px;
}

.arch-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.arch-item {
  background: white;
  border-radius: 24px;
  padding: 24px;
}

/* 合规认证 */
.compliance-badge {
  display: inline-block;
  background: var(--abp-accent-gold);
  color: #1e3c3c;
  padding: 8px 18px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
}

/* FAQ */
.faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--abp-gray-border);
}

.faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--abp-text-dark);
}

.faq-question i {
  color: var(--abp-accent-gold);
}

.faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

.cta-block {
  background: var(--abp-primary-dark);
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.cta-block h2 {
  color: white;
}

.cta-block .btn-primary {
  background-color: white;
  color: var(--abp-primary-dark);
  margin: 0 8px;
}

.cta-block .btn-outline {
  border-color: white;
  color: white;
}

.cta-block .btn-outline:hover {
  background-color: white;
  color: var(--abp-primary-dark);
}

/* 模态框 */
.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  border-radius: 40px;
  max-width: 500px;
  width: 90%;
  padding: 40px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.3);
  position: relative;
}

.close-modal {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.modal h3 {
  margin-bottom: 24px;
}

.modal .form-group {
  margin-bottom: 20px;
}

.modal input, .modal textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid var(--abp-gray-border);
  border-radius: 30px;
  font-size: 1rem;
  outline: none;
}

.modal textarea {
  border-radius: 20px;
}

.modal .btn {
  width: 100%;
  margin-top: 10px;
}

footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--abp-gray-border);
  margin-top: 40px;
}

/* 响应式 */
@media (max-width: 1000px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid, .dimension-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid, .dimension-grid {
    grid-template-columns: 1fr;
  }
  .abp-page h1 { font-size: 2.5rem; }
}
</style>
